import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Box, HStack } from "native-base";
import { invariant, isWeb } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import useResponsive from "../../util/useResponsive";
import ListHeader from "../../molecules/ListHeader";
import Paper from "../../atoms/Paper";
import Headline from "../../molecules/Headline";
import Button from "../../atoms/Button";
import ButtonLink from "../../atoms/ButtonLink";
import { usePregnancyData } from "../../providers";
import PregnancyEditor from "./PregnancyEditor";
const PregnancyDoctorEdit = ({ uploadDocuments, handleDeletePress, triggerEdit, }) => {
    var _a, _b;
    const { isSmallScreen } = useResponsive();
    const { patient, pregnancyData } = usePregnancyData();
    const [editedPregnancyData, setEditedPregnancyData] = useState(Object.assign(Object.assign({}, pregnancyData), { patientId: patient.userId, genderMethod: (_a = pregnancyData.genderMethod) !== null && _a !== void 0 ? _a : "genetic" }));
    const editPregnancyData = (key, value, infant) => {
        setEditedPregnancyData((prevState) => {
            const updatedInfants = prevState.infants.map((item, index) => {
                if (infant !== undefined && infant === index) {
                    return Object.assign(Object.assign({}, item), { [key]: value });
                }
                return item;
            });
            const changedValue = !infant && {
                [key]: value,
            };
            return Object.assign(Object.assign(Object.assign({}, prevState), changedValue), { infants: updatedInfants });
        });
    };
    invariant(editPregnancyData);
    const { t } = useTranslation();
    return (_jsxs(Box, Object.assign({ flex: {
            base: isWeb ? "initial" : 1,
            md: 1,
        } }, { children: [isSmallScreen && (_jsx(ListHeader, { title: t("pregnancy:informationConnectedToPregnancy"), size: "xs", borderBottomWidth: 0, bgColor: "none", px: 4 })), _jsxs(Paper, Object.assign({ borderRadius: "lg", flex: isWeb ? 1 : 0 }, { children: [!isSmallScreen && (_jsx(Headline, { title: t("pregnancy:informationConnectedToPregnancy"), size: "xs" })), _jsxs(Box, Object.assign({ width: "100%" }, { children: [_jsx(PregnancyEditor, { pregnancyData: editedPregnancyData, editPregnancyData: editPregnancyData, uploadDocuments: uploadDocuments, handleDeletePress: handleDeletePress, hasPatientEdited: ((_b = pregnancyData === null || pregnancyData === void 0 ? void 0 : pregnancyData.createdBy) === null || _b === void 0 ? void 0 : _b.role) === "patient" }), _jsxs(HStack, Object.assign({ justifyContent: "space-between", width: "full", borderTopWidth: 1, borderTopColor: "gray.100", borderTopStyle: "solid", mt: 4, p: 6 }, { children: [_jsx(ButtonLink, Object.assign({ route: "patient", params: { patientId: patient.userId }, variant: "outlined" }, { children: "Vissza" })), _jsx(Button, Object.assign({ onPress: () => triggerEdit(editedPregnancyData) }, { children: t("save") }))] }))] }))] }))] })));
};
export default PregnancyDoctorEdit;
